import { render, staticRenderFns } from "./photo-reports-list.pug?vue&type=template&id=28237a32&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./photo-reports-list.scss?vue&type=style&index=0&id=28237a32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28237a32",
  null
  
)

export default component.exports